import type { MethodName, Tag } from "../apiClient";
import type { Args } from "../queryTypes";

import { getQueryKey } from "./getQueryKey";

export type InvalidateQueriesData = {
    [T in Tag]?:
        | {
              [M in MethodName<T>]?: Partial<Args<T, M>> | true;
          }
        /** true invalidates every query of the tag */
        | true;
};

export const getInvalidationQueryKeys = (invalidateQueriesData: InvalidateQueriesData) => {
    const tags = Object.keys(invalidateQueriesData) as Array<Tag>;

    return tags.flatMap((tag) => {
        if (!invalidateQueriesData[tag]) {
            return undefined;
        }

        if (invalidateQueriesData[tag] === true) {
            return [getQueryKey({ tag })];
        }

        const methodNames = Object.keys(invalidateQueriesData[tag]) as Array<MethodName<Tag>>;

        return methodNames.map((methodName) => {
            const args =
                invalidateQueriesData[tag]?.[methodName] === true ? [] : invalidateQueriesData[tag]?.[methodName];

            return getQueryKey({ tag, methodName, args });
        });
    });
};
